<template lang="pug">
footer
  b-container
    a-row
      a-col.text-left(
        :span="12"
      )
        img.pr-1(
          src="/repository/img/logo_mfar.png"
          height="10"
        )
        span.mfar-m M
        span.mfar-far.mr-1 FAR
        span Medical Technology
      a-col.text-right(
        :span="12"
      )
        cau-link
</template>

<script>
import CauLink from '@/components/CauLink';

export default {
  components: {
    CauLink,
  },
};
</script>

<style scoped>
footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  background-color: #f3f3f3;
  font-size: 12px;
}
.mfar-m {
  color: #1476c6;
  font-weight: bold;
}
.mfar-far {
  color: #709acf;
  font-weight: bold;
}
</style>
